import { EventHubAnalyticsProviderPlugin } from './eventHub';
export var plugins = [new EventHubAnalyticsProviderPlugin()];